import React from 'react';
import { FlameIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { Countdown } from './Countdown';
type CtaBlockProps = {
  label?: string;
  note?: string;
  id?: string;
};
export function CtaBlock({
  label = '🔥 VOGLIO IL SISTEMA MAESTRO DI SALDATURA',
  note = 'Pagamento unico · Accesso immediato · Accesso a vita · Garanzia di 7 giorni',
  id
}: CtaBlockProps) {
  return <div id={id} className="flex flex-col items-center gap-5" data-id="element-26" data-mp="1zpstrhufiap2">
      <a href={CHECKOUT_URL} className="group w-full max-w-xl rounded-xl bg-forge px-5 py-4 text-center font-display text-xl leading-tight sm:text-2xl font-bold uppercase tracking-wide text-white shadow-[0_10px_0_0_#a5330c] transition-[transform,background-color] duration-150 ease-out hover:bg-forge-light active:translate-y-1 active:shadow-[0_4px_0_0_#a5330c] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-forge-light" data-id="element-27" data-mp="24p5he4t4jlsp">
        {label}
      </a>
      <Countdown data-id="element-28" data-mp="102xmr69x6i8u" />
      {note ? <p className="max-w-md text-center text-[12px] font-medium leading-relaxed text-mute sm:text-sm" data-id="element-29" data-mp="103z5lwx6g914">
          {note}
        </p> : null}
    </div>;
}
type MiniCtaProps = {
  label: string;
};

/** Transformational button used at the close of each section. */
export function MiniCta({
  label
}: MiniCtaProps) {
  return <a href={CHECKOUT_URL} className="mx-auto mt-8 flex w-full max-w-md items-center justify-center gap-2 rounded-lg border-2 border-forge bg-forge/10 px-4 py-3.5 text-center font-display text-base font-bold uppercase tracking-wide text-forge-light transition-[background-color,color,transform] duration-150 ease-out hover:bg-forge hover:text-white active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-forge-light sm:text-lg" data-id="element-30" data-mp="1j2bjfvz1a731">
      <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-31" data-mp="1wtzv5y5detjh" />
      {label}
    </a>;
}